<div class="ili-panel password_panel">
  <div class="input-group input-group-sm password_content">
    <span class="input-group-addon"><input value="true" [checked]="block.data.password" [(ngModel)]="block.data.password" type="checkbox"></span>
    <span class="form-control">Enable Password Reset</span>
  </div>
</div>
